
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Products from './Products';

const ProductGroups = (props) => {
  return (
    <Fragment>
      {props.productGroups.map((productGroup) => {
        return (
          <div className="choiceContainer" key={productGroup.id}>
            <div className="topContainer">
              <div className="productSide">
                <h2>{props.generalTranslations[productGroup.title] || productGroup.title}</h2>
               <div
                 className="helpButton"
                 onClick={() => props.toggleHelpAlert()}
                 role="button"
                 tabIndex="0"
               >
                  {props.generalTranslations.NeedHelp}
               </div>
              </div>
              <div className="previewSide">
                <h2>{props.generalTranslations.SelectedKit}</h2>
              </div>
            </div>
            {productGroup.choices.sort((a, b) => a.order_by - b.order_by).map(choice => (<Products
              key={choice.id}
              choiceID={choice.id}
              productGroupID={props.productGroupID}
              productGroupTitle={choice.title}
              products={choice.products}
              discount={choice.discount_percentage}
              productSubgroupID={productGroup.id}
            />))}
          </div>
        );
      })}

    </Fragment>

  );
};

const mapState = state => (
  {
    generalTranslations: state.generalTranslations,
  }
);

export default connect(mapState, null)(ProductGroups);
